import React, { useState, useEffect } from 'react'
import { NavLink } from 'react-router-dom'

export default function Products() {
  const [data, setData] = useState([])
  const [filter, setFilter] = useState(data)
  const [loading, setLoading] = useState(false)
  
  useEffect(() => {
    let componentMounted = true
    const getProducts = async () => {
      setLoading(true)
      const response = await fetch(`https://fakestoreapi.com/products`)
      if (componentMounted) {
        setData(await response.clone().json())
        setFilter(await response.json())
        setLoading(false)
      }

      return () => {
        componentMounted = false
      }
    }
    getProducts()
  }, [])

  const Loading = () => {
    return (
      <>
        Loading...
      </>
    )
  }

  const filterProduct = (cat) => {
    const updateList = data.filter((x) => x.category === cat)
    setFilter(updateList)
  }

  const ShowProducts = () => {
    return (
      <>
        <div className="buttons d-flex justify-content-center mb-5 pb-5">
          <button
            className="btn btn-outline-dark me-2"
            onClick={() => setFilter(data)}>All</button>

          <button
            className="btn btn-outline-dark me-2"
            onClick={() => filterProduct("men's clothing")}>Para Homens</button>

          <button
            className="btn btn-outline-dark me-2"
            onClick={() => filterProduct("women's clothing")}>Para Mulheres</button>

          <button
            className="btn btn-outline-dark me-2"
            onClick={() => filterProduct("jewelery")}>Joias de luxo</button>

          <button
            className="btn btn-outline-dark me-2"
            onClick={() => filterProduct("electronics")}>Electronicos</button>

        </div>
        {filter.map((product) => {
          return (
            <div className="col-md-3 mb-4" key={product.id}>
              <div className="card h-100 text-center p-4">
                <img src={product.image} className="card-img-top" style={{ objectFit: 'contain' }} alt={product.title} height="250px" />
                <div className="card-body">
                  <h5 className="card-title mb-0">{product.title.substring(0, 12)}</h5>
                  <p className="card-text lead fw-bold">{product.price}</p>
                  <NavLink to={`/products/${product.id}`} className="btn btn-outline-dark">Comprar</NavLink>
                </div>
              </div>
            </div>
          )
        })}
      </>
    )
  }

  return (
    <div>
      <div className="container my-5 py-5">
        <div className="row">
          <div className="col-12 mb-5">
            <h1 className='display-6 fw-bolder text-center'>Lista de Produtos</h1>
            <hr />
          </div>
        </div>
        <div className="row justify-content-center">
          {loading ? <Loading /> : <ShowProducts />}
        </div>
      </div>
    </div>
  )
}
